import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import WalletListItem from '@/components/wallet-list-item';
import useBottomSheetStore from '@/store/bottom-sheet-store';
import OtherWallets from '@/components/other-wallets';
import { useGetSegments } from '@/services/hooks';
import { useEffect } from 'react';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import cn from '@/lib/clsxm';
import { SegmentProps } from '@/components/wallets-section/types';
import useHomeStore from '@/store/home';
import AssetLoading from '@/components/@base/asset-loading';
import { getFromSessionStorage, isDesktop } from '@/lib/helper';
import FontIcon from '@/components/@base/font-icon';
import { segment } from '@/services/models/api.models';
import useCommonModalStore from '@/store/common-modal-store';

const WalletsSection = ({ isBankCardMode }: { isBankCardMode?: boolean }) => {
  const { setShowBottomSheet } = useBottomSheetStore();
  const { setShow } = useCommonModalStore();
  const {
    setSegments,
    setUnusableSegments,
    setZeroBalanceSegments,
    segments,
    unusableSegments,
    zeroBalanceSegments,
    setIsSegmentLoading,
    refetchSegments,
    setRefetchSegments,
  } = useUserWalletsVouchersStore();
  const { invoice } = useHomeStore();
  const {
    data,
    isLoading,
    isError,
    refetch: refetchUserSegments,
  } = useGetSegments(invoice > 0);
  const showOtherWallets = () => {
    if (unusableSegments?.length > 0 || zeroBalanceSegments?.length > 0) {
      if (isDesktop()) {
        setShow(true, {
          center: true,
          Body: () => <OtherWallets />,
        });
      } else {
        setShowBottomSheet(true, {
          Body: () => <OtherWallets />,
        });
      }
    }
  };
  useEffect(() => {
    if (data?.usableSegments) {
      if (data?.usableSegments?.length === 0) sessionStorage.setItem('walletsIsEmpty', 'true');
      const editedSegments: SegmentProps[] = [];
      data?.usableSegments?.map((s: segment) => {
        editedSegments.push({
          ...s,
          selected: false,
          usageBalance: 0,
          isEdited: false,
        });
      });
      setSegments(editedSegments);
    }
    if (data?.unusableSegments) setUnusableSegments(data?.unusableSegments);
    if (data?.zeroBalanceSegments) setZeroBalanceSegments(data?.zeroBalanceSegments);
    if (data) setIsSegmentLoading(false);
  }, [data]);
  useEffect(() => {
    if (refetchSegments) {
      refetchUserSegments().then(() => {
        setRefetchSegments(false);
      });
    }
  }, [refetchSegments]);
  if (isBankCardMode && !data?.hasOzoneCard) return null;
  if (!segments || segments?.length === 0) return null;
  return (
    <Container center className='mt-3 w-full flex-col'>
      <Container
        center
        className='w-full justify-between gap-2 p-4 pl-[25px] md:justify-start'
      >
        <Text className='text-lg text-grayLight-1000 dark:text-grayLight-0' medium>
          {isBankCardMode ? localization.bankCard : localization.wallets}
        </Text>
        {getFromSessionStorage('editableWallets') && !isBankCardMode && (
          <FontIcon
            icon='icon-circle-information'
            className={cn(
              'cursor-pointer text-xl text-grayLight-650 dark:text-grayLight-650',
              unusableSegments.length === 0 && zeroBalanceSegments.length === 0 && 'hidden',
            )}
            onClick={showOtherWallets}
          />
        )}
      </Container>
      {isLoading && <AssetLoading />}
      {(segments?.length === 0 || isError) && !isLoading && (
        <Container className='mx-auto flex w-full justify-start gap-3 py-4 pr-4'>
          <Text className='text-[13px] text-grayLight-600 dark:text-grayDark-300'>
            {localization.youHaveNoWallet}
          </Text>
        </Container>
      )}
      <Container className='w-full'>
        {segments?.length > 0 &&
          data?.hasOzoneCard &&
          isBankCardMode &&
          segments
            .filter((s) => s.isMainSegment)
            .map((item, index) => (
              <WalletListItem
                className='lg:first:rounded-t-xl lg:last:rounded-b-xl'
                hasOzoneCard={data?.hasOzoneCard && isBankCardMode}
                key={index}
                data={item}
              />
            ))}

        {segments?.length > 0 &&
          data?.hasOzoneCard &&
          !isBankCardMode &&
          segments
            .filter((s) => !s.isMainSegment)
            .map((item, index) => (
              <WalletListItem
                className='lg:first:rounded-t-xl lg:last:rounded-b-xl'
                hasOzoneCard={data?.hasOzoneCard && isBankCardMode}
                key={index}
                data={item}
              />
            ))}

        {segments?.length > 0 &&
          !data?.hasOzoneCard &&
          !isBankCardMode &&
          segments.map((item, index) => (
            <WalletListItem
              className='lg:first:rounded-t-xl lg:last:rounded-b-xl'
              hasOzoneCard={data?.hasOzoneCard && isBankCardMode}
              key={index}
              data={item}
            />
          ))}
      </Container>
    </Container>
  );
};
export default WalletsSection;
